import React, { Component, Suspense } from "react";
import * as ReactDOM from "react-dom";
import edit from "../image/icons/edit.png"
import plus from "../image/icons/plus.png"
import locationimg from "../image/sutlej/location.png"
import $ from "jquery";
import InnerHTML from "dangerously-set-html-content";
const folderName = window.sessionStorage.getItem("homeName");

export default class Welcome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      aboutData: [],
      sectionName: 'About',
      parentName: ''

    };
  }
  componentDidMount() {

    // setInterval(async () => {
    const About = JSON.parse(window.sessionStorage.getItem("About"));
    if (About) {
      this.setState({ aboutData: About });
      this.setState({ parentName: About[0].parentName });

    } else {
      this.setState({ aboutData: [] });

      // window.location.reload(false);
    }
    // }, 5000);
  }

  addClick(sid, pId, cId, ptitle, pstitle, cTitile, cdescri, childImg, sOrder) {
    if ($("#aboutParentId").val() !== "") {
      pId = $("#aboutParentId").val();
    }
    if (childImg) {
      var splitImg = childImg.split("theme/")
      childImg = splitImg[1];
    }

    const LazyPage = React.lazy(() => import("../" + folderName + "/ThemeComponent"));
    ReactDOM.render(
      <div>
        <Suspense fallback={<div>Loading...</div>}>
          <section>
            <LazyPage
              sessionId={sid}
              parentId={pId}
              childId={cId}
              patentTitle={ptitle}
              parentSubTitle={pstitle}
              childTitle={cTitile}
              childDesri={cdescri}
              sectionName={this.state.sectionName}
              childImg={childImg}
              sortSubOrder={sOrder}
            />
          </section>
        </Suspense>
      </div>,
      document.getElementById("aboutpopUpBlock")
    );
    $("#aboutpopUpBlock").addClass('editActive');
  }
  render() {
    const urlPath = window.location.origin.toString();
    return (

      <div class="welcomeMain dashContent">
        {this.props.themeFlag === "theme" && (
          <div className="editIconSec" id="About">
            <span className="editIcon editAddIcon" title="Add" onClick={() => this.addClick("5", "", "", "", "", "", "", "", "", "")}><img src={plus} alt="Add" /></span>
          </div>
        )}
        <div className="cmsContentDiv" id="aboutpopUpBlock"></div>
        {this.props.themeFlag === "theme" && (
          <div class="col-md-12">
            <h4 class="mainHead text-center" style={{ zIndex: "1" }}>{this.state.parentName != '' ? 'Welcome Session' : 'Welcome Session'}</h4>
          </div>
        )}
        <input type="hidden" id="aboutSectionId" value="5" />
        {this.state.aboutData.map((ban) => {
          return (
            <div>
              <input type="hidden" id="aboutParentId" value={ban.parentId} />
              {ban.sectionList.length !== "0" && (
                <div>
                  {ban.sectionList.map((data, index) => (
                    <div class="row">
                      {this.props.themeFlag === "theme" && (
                        <div className="editIconSec editIconSecTop">
                          <span className="editIcon editAddIcon" title="Edit"
                            onClick={() => this.addClick
                              (ban.sectionId,
                                ban.parentId,
                                data.childId,
                                ban.parentName,
                                ban.parentSubTitle,
                                data.childName,
                                data.childDescription,
                                data.childImage,
                                data.homeAdsSubSortOrder)}><img src={edit} alt="logo" /></span>
                        </div>
                      )}
                      <div class="col-md-12">
                        <h4 class="mainHead text-center"><span>{ban.parentName}</span></h4>
                      </div>
                      <div class="welcomeMainSub row">
                        <div class="col-lg-5 text-left pb-3 d-block d-lg-none text-md-center">
                          <img src={data.childImage} alt="" class="welcome-imgg image-wrap img-fluid"></img>
                        </div>
                        <div class="col-lg-7 welcome-text">
                          <div className="col-md-12 p-0 welcome-text-div">
                            <p className="welcome-text-p">
                              <InnerHTML html={data.childDescription.length > 600 ?
                                data.childDescription.substring(0, data.childDescription.substring(0, 600).lastIndexOf(" ")) + '...'
                                :
                                data.childDescription} />
                            </p>
                          </div>
                          {data.childDescription.length > 600 ?
                            <div className="col-md-12 p-0 mt-0 mt-lg-4 text-right">
                              <a href={(urlPath, "/1-aboutMe")} class="aboutButton">Read More</a>
                            </div>
                            : ''}
                        </div>
                        <div class="col-lg-5 text-center d-none d-lg-block pt-3">
                          <img src={data.childImage} alt="" class="welcome-imgg image-wrap img-fluid"></img>
                        </div>

                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}

      </div>
    );
  }
}
